import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';
import { Card, EmptyState } from '@/ui';

/**
 * SONRAKI FAZLARIN YER TUTUCUSU.
 *
 * Ekranin kendisi henuz yok; ROTA, MENU ve KORUMALAR ise GERCEK. Bu bilincli:
 * yetki/bolge mantigi ancak gercek adreslerle sinanabilir, ve ekranlar geldikce
 * yalniz bu bilesenin yerine gecerler — rota agacina dokunulmaz.
 *
 * `titleKey` metin degil ANAHTAR; degeri menus.ts'ten geliyor ve orada
 * src/i18n/__tests__/keys.test.ts tarafindan dogrulaniyor.
 */
// Prop'lar BILINCLI olarak destructure EDILMEDI: `{ titleKey }` yazimi,
// anahtarlarin JSX icinde t() olmadan basilmasini yakalayan testin (bkz.
// src/i18n/__tests__/keys.test.ts) desenine birebir uyuyor ve yanlis pozitif
// uretiyordu. Testi gevsetmek yerine cagri yerini degistirdik — o test
// gercekten calisan bir siniri koruyor.
export function PlaceholderPage(props: { titleKey: string }) {
  const { t } = useTranslation();
  return (
    <Card padding="lg">
      <EmptyState
        icon={<Clock size={28} aria-hidden="true" />}
        title={t(props.titleKey)}
        description={t('common.comingSoon')}
      />
    </Card>
  );
}
